import Immutable from 'seamless-immutable';
//import fileDownload from 'js-file-download';
import axios from 'axios';
import config from '../config';
import { SubmissionError } from 'redux-form';
import { initialCheckAuth } from './auth';

// Костыль для IOS и Safari
const pdfDownload = async (params, cb, url = config.api) => {
  try {
    var repForm = document.createElement('form');
    repForm.setAttribute('id', 'repForm');
    repForm.setAttribute('action', url);
    repForm.setAttribute('method', 'post');
    repForm.setAttribute('hidden', 'true');
    for (var key in params) {
      let kp = params[key];
      if (key === 'data') {
      } else {
        kp = kp.replace(/"/g, "'");
      }
      const input = document.createElement('input');
      input.setAttribute('type', 'text');
      input.setAttribute('name', key);
      input.setAttribute('value', kp);
      repForm.appendChild(input);
    }
    document.body.appendChild(repForm);
    await repForm.submit();
    const elem = document.getElementById('repForm');
    elem.parentNode.removeChild(elem);
    cb(null);
  } catch (error) {
    cb(error.message);
  }
};

const prefix = 'App';

const INITIAL_APP_DATA_BEGIN = `${prefix}/INITIAL_APP_DATA_BEGIN`;
const INITIAL_APP_DATA_SUCCEED = `${prefix}/INITIAL_APP_DATA_SUCCEED`;
const INITIAL_APP_DATA_FAILED = `${prefix}/INITIAL_APP_DATA_FAILED`;

const initialAppDataStart = () => ({
  type: INITIAL_APP_DATA_BEGIN
});

const initialAppDataSucceed = data => ({
  type: INITIAL_APP_DATA_SUCCEED,
  data
});

const initialAppDataFailed = error => ({
  type: INITIAL_APP_DATA_FAILED,
  error
});

export const initialAppData = () => (dispatch, getState, api) => {
  dispatch(initialAppDataStart());
  api({ operation: 'App.getData', ns: 'Lkk' })
    .then(response => {
      const result = response.data;
      if (!result.success) throw new Error(response);
      dispatch(initialAppDataSucceed(result.data));
      dispatch(initialCheckAuth());
    })
    .catch(error => {
      dispatch(
        initialAppDataFailed(
          !!error.response ? error.response.data.error : 'Произошла серверная ошибка'
        )
      );
    });
};

// ПФ договора
const PDF_DOWNLOAD_START = `${prefix}/PDF_DOWNLOAD_START`;
const PDF_DOWNLOAD_END = `${prefix}/PDF_DOWNLOAD_END`;

const pdfDownloadStart = () => ({
  type: PDF_DOWNLOAD_START
});

const pdfDownloadEnd = () => ({
  type: PDF_DOWNLOAD_END
});

export const downloadPdf = (docCode, reportCode) => dispatch => {
  dispatch(pdfDownloadStart());
  const params = {
    operation: 'App.getPolicyPdf',
    ns: 'Lkk'
  };
  const values = {
    docCode,
    reportCode,
    type: 1
  };

  pdfDownload({ ...params, data: JSON.stringify(values) }, err => {
    if (err) {
      console.log(err);
    }
    dispatch(pdfDownloadEnd());
  });
};

// Загрузка соглашения о присоединении
const AGREEMENT_DOWNLOAD_START = `${prefix}/AGREEMENT_DOWNLOAD_START`;
const AGREEMENT_DOWNLOAD_END = `${prefix}/AGREEMENT_DOWNLOAD_END`;

const agreementDownloadStart = () => ({
  type: AGREEMENT_DOWNLOAD_START
});

const agreementDownloadEnd = () => ({
  type: AGREEMENT_DOWNLOAD_END
});

export const downloadAgreement = () => (dispatch, getState, api) => {
  dispatch(agreementDownloadStart());
  const params = {
    operation: 'App.getAgreement',
    ns: 'Lkk'
  };
  const values = {};

  pdfDownload({ ...params, data: JSON.stringify(values) }, err => {
    if (err) {
      console.log(err);
    }
    dispatch(agreementDownloadEnd());
  });
};

// Загрузка заявления о присоединении
const STATEMENT_DOWNLOAD_START = `${prefix}/STATEMENT_DOWNLOAD_START`;
const STATEMENT_DOWNLOAD_END = `${prefix}/STATEMENT_DOWNLOAD_END`;

const statementDownloadStart = () => ({
  type: STATEMENT_DOWNLOAD_START
});

const statementDownloadEnd = () => ({
  type: STATEMENT_DOWNLOAD_END
});

export const downloadStatement = () => (dispatch, getState, api) => {
  dispatch(statementDownloadStart());
  const params = {
    operation: 'App.getStatement',
    ns: 'Lkk'
  };
  const values = {
    user: getState().auth.rawInfo.code
  };

  pdfDownload({ ...params, data: JSON.stringify(values) }, err => {
    if (err) {
      console.log(err);
    }
    dispatch(statementDownloadEnd());
  });
};

export const sendPetition =
  ({ files, ...otherData }) =>
  (dispatch, getState, api) => {
    const formData = new FormData();
    formData.append('operation', 'App.sendPetition');
    formData.append('ns', 'Lkk');
    formData.append('data', JSON.stringify({ ...otherData, user: getState().auth.rawInfo.code }));

    if (files) {
      for (var i = 0; i < files.length; i++) {
        formData.append('file[]', files[i], files[i].name);
      }
    }

    return axios({
      method: 'post',
      url: config.api,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      withCredentials: true
    })
      .then(function (response) {
        //handle success
        return response.data;
      })
      .catch(error => {
        let err = error.response
          ? error.response.data.error
          : 'Произошла неизвестная ошибка. Попробуйте позже.';
        throw new SubmissionError({ _error: err });
      });
  };

export const sendPetitionComment =
  ({ files, comment, petition }) =>
  (dispatch, getState, api) => {
    const formData = new FormData();
    formData.append('operation', 'App.sendPetitionComment');
    formData.append('ns', 'Lkk');
    formData.append(
      'data',
      JSON.stringify({ comment, petition, user: getState().auth.rawInfo.code })
    );

    if (files) {
      for (var i = 0; i < files.length; i++) {
        formData.append('file[]', files[i], files[i].name);
      }
    }

    return axios({
      method: 'post',
      url: config.api,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      withCredentials: true
    })
      .then(function (response) {
        //handle success
        return response.data;
      })
      .catch(error => {
        let err = error.response
          ? error.response.data.error
          : 'Произошла неизвестная ошибка. Попробуйте позже.';
        throw new SubmissionError({ _error: err });
      });
  };

export const readPetition = code => {
  return (dispatch, getState, api) => {
    const params = {
      operation: 'App.readPetition',
      ns: 'Lkk'
    };

    const values = {
      code,
      user: getState().auth.rawInfo.code
    };

    return api({ ...params, data: JSON.stringify(values) })
      .then(response => {
        const result = response.data;
        return result;
      })
      .catch(error => {
        return { success: false };
      });
  };
};

const EXTERNAL_PDF_DOWNLOAD_START = `${prefix}/EXTERNAL_PDF_DOWNLOAD_START`;
const EXTERNAL_PDF_DOWNLOAD_SUCCEED = `${prefix}/EXTERNAL_PDF_DOWNLOAD_SUCCEED`;
const EXTERNAL_PDF_DOWNLOAD_FAILED = `${prefix}/EXTERNAL_PDF_DOWNLOAD_FAILED`;
const externalPdfDownloadStart = () => ({
  type: EXTERNAL_PDF_DOWNLOAD_START
});
const externalPdfDownloadSucceed = () => ({
  type: EXTERNAL_PDF_DOWNLOAD_SUCCEED
});
const externalPdfDownloadFailed = error => ({
  type: EXTERNAL_PDF_DOWNLOAD_FAILED,
  error
});
export const getExternalPdf = contract => (dispatch, getState, api) => {
  dispatch(externalPdfDownloadStart());
  const params = {
    operation: 'App.getExternalPdf',
    ns: 'Lkk'
  };
  const values = {
    contract
  };
  pdfDownload({ ...params, data: JSON.stringify(values) }, err => {
    if (err) {
      dispatch(externalPdfDownloadFailed(err));
    }
    dispatch(externalPdfDownloadSucceed());
  });
};

// Скачать XLS
const XLS_DOWNLOAD_START = `${prefix}/XLS_DOWNLOAD_START`;
const XLS_DOWNLOAD_END = `${prefix}/XLS_DOWNLOAD_END`;

const xlsDownloadStart = () => ({
  type: XLS_DOWNLOAD_START
});

const xlsDownloadEnd = () => ({
  type: XLS_DOWNLOAD_END
});

export const downloadXls =
  ({ dataset, filename, listname }) =>
  (dispatch, getState, api) => {
    dispatch(xlsDownloadStart());
    const params = {
      operation: 'downloadExcel'
    };
    const values = {
      dataset,
      filename,
      listname
    };

    pdfDownload({ ...params, data: JSON.stringify(values) }, err => {
      if (err) {
        console.log(err);
      }
      dispatch(xlsDownloadEnd());
    });

    // return api({ ...params, data: JSON.stringify(values) })
    //   .then(response => {
    //     dispatch(xlsDownloadEnd());
    //   })
    //   .catch(error => {
    //     dispatch(xlsDownloadEnd());
    //     return { success: false };
    //   });
  };

const initialState = Immutable({
  contractSeries: [],
  feedBackThemes: [],
  petitionsConfigs: [],
  appDataInProgress: false,
  appDataError: '',
  pdfDownloadInProgress: false,
  agreementDownloadInProgress: false,
  statementDownloadInProgress: false,
  externalPdfDownloadInProgress: false,
  externalPdfDownloadError: '',
  xlsDownloading: false
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case XLS_DOWNLOAD_START:
      return Immutable.merge(state, {
        xlsDownloading: true
      });

    case XLS_DOWNLOAD_END:
      return Immutable.merge(state, {
        xlsDownloading: false
      });

    case INITIAL_APP_DATA_BEGIN:
      return Immutable.merge(state, {
        appDataInProgress: true,
        appDataError: ''
      });

    case INITIAL_APP_DATA_SUCCEED:
      return Immutable.merge(state, {
        appDataInProgress: false,
        contractSeries: action.data.contractSeries,
        feedBackThemes: action.data.feedBackThemes,
        petitionsConfigs: action.data.petitionsConfigs,
        regions: action.data.regions
      });

    case INITIAL_APP_DATA_FAILED:
      return Immutable.merge(state, {
        appDataInProgress: false,
        appDataError: action.error
      });

    case PDF_DOWNLOAD_START:
      return Immutable.merge(state, {
        pdfDownloadInProgress: true
      });

    case PDF_DOWNLOAD_END:
      return Immutable.merge(state, {
        pdfDownloadInProgress: false
      });

    case AGREEMENT_DOWNLOAD_START:
      return Immutable.merge(state, {
        agreementDownloadInProgress: true
      });

    case AGREEMENT_DOWNLOAD_END:
      return Immutable.merge(state, {
        agreementDownloadInProgress: false
      });

    case STATEMENT_DOWNLOAD_START:
      return Immutable.merge(state, {
        statementDownloadInProgress: true
      });

    case STATEMENT_DOWNLOAD_END:
      return Immutable.merge(state, {
        statementDownloadInProgress: false
      });

    case EXTERNAL_PDF_DOWNLOAD_START:
      return Immutable.merge(state, {
        externalPdfDownloadInProgress: true
      });

    case EXTERNAL_PDF_DOWNLOAD_SUCCEED:
      return Immutable.merge(state, {
        externalPdfDownloadInProgress: false,
        externalPdfDownloadError: ''
      });

    case EXTERNAL_PDF_DOWNLOAD_FAILED:
      return Immutable.merge(state, {
        externalPdfDownloadInProgress: false,
        externalPdfDownloadError: action.error
      });

    default:
      return state;
  }
};

export default reducer;
